(function () {
    'use strict';

    angular
        .module('app.home')
        .component('sc3Home', {
            templateUrl: 'app/home/home.component.html',
            controller: HomeComponent
        });

    HomeComponent.$inject = ['user', 'upgradeModal', 'clubMembershipLevelType'];
    function HomeComponent(user, upgradeModal, clubMembershipLevelType) {
        var ctrl = this;
        ctrl.showUpgradeModal = upgradeModal;
        ctrl.isBritishColumbia = user.clubManagementGroupId === 3;

        Object.defineProperty(ctrl, 'canUpgrade', { get: getCanUpgrade });

        function getCanUpgrade() {
            return user.membershipLevel === clubMembershipLevelType.Bronze;
        }
    }
})();